import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../context/authContext";
import { useChat } from "../../../context/chatContext";
import createAxiosInstance from "../../../utils/axiosConfig";
import { useCases } from "../../../utils/constants";
import {
	framework_domains,
	question_flows,
	user_flow_scores,
} from "../../../utils/endpoints";
import {
	FlowScore,
	FrameworkDomain,
	QuestionFlow,
} from "../../../utils/interfaces";
import ChatHeader from "../../common/chat/chatHeader";
import ChatHistory from "../../common/chatHistory";
import Footer from "../../common/footer";
import QuestionsFlow from "../../common/maturityAssessment/questionsFlow";

const MaturityAreas = () => {
	const { startChat, resetChatState, setSelectedUseCase } = useChat();
	const navigate = useNavigate();
	const { frameworkId, domainId } = useParams();
	const { userId, logout } = useAuth();

	const [, setDomains] = useState<FrameworkDomain[]>([]);
	const [isSelecting, setIsSelecting] = useState(false);
	const [selectedDomain, setSelectedDomain] = useState<FrameworkDomain>();
	const [questionFlows, setQuestionFlows] = useState<QuestionFlow[]>([]);
	const [flowScores, setFlowScores] = useState<FlowScore[]>([]);
	const [latestScores, setLatestScores] = useState<FlowScore[]>([]);
	const [refresh, setRefresh] = useState<number>(0);

	const handleSelect = async (index: number) => {
		if (isSelecting) return;
		resetChatState();
		// Set the selected use case
		setSelectedUseCase(index);
		setIsSelecting(true);
		if (index === useCases[0].value) {
			navigate(useCases[0].route);
		} else if (index === useCases[1].value) {
			navigate(useCases[1].route);
		} else if (index === useCases[2].value) {
			navigate(useCases[2].route);
		} else if (index === useCases[3].value) {
			navigate(useCases[3].route);
		}
		setIsSelecting(false);
	};

	const fetchDomains = async (frameworkId: number) => {
		try {
			const domains = await createAxiosInstance().get(
				framework_domains(frameworkId)
			);
			if (domains.status == 401 || domains.status == 403) {
				// 401 is for expired token
				// 403 is for forbidden access (blocked by GPT.)
				console.log("use token expired");
				logout();
				navigate("/");
				return;
			}
			setDomains(domains?.data);

			const selectedDomain = domains?.data?.find(
				(domain: FrameworkDomain) => domain.id === Number(domainId)
			);
			setSelectedDomain(selectedDomain);
		} catch (e) {
			console.log(e);
		}
	};

	const getLatestScores = (
		scores: FlowScore[],
		questionFlows: QuestionFlow[]
	) => {
		const latestScoresMap = new Map<number, FlowScore>();

		// Filter scores to only include those with question_flow_id matching any id in questionFlows
		const validScores = scores.filter((score) =>
			questionFlows.some((flow) => flow.id === score.question_flow_id)
		);

		validScores.map((score) => {
			const existingScore = latestScoresMap.get(score.question_flow_id);
			if (
				!existingScore ||
				new Date(score.score_date) > new Date(existingScore.score_date)
			) {
				latestScoresMap.set(score.question_flow_id, score);
			}
		});

		return Array.from(latestScoresMap.values());
	};

	useEffect(() => {
		fetchDomains(Number(frameworkId));
	}, []);

	useEffect(() => {
		const fetchQuestionsFlow = async () => {
			if (!selectedDomain) return;

			try {
				const questionsFlowResponse = await createAxiosInstance().get(
					question_flows(selectedDomain?.id ?? 0)
				);

				if (
					questionsFlowResponse.status == 401 ||
					questionsFlowResponse.status == 403
				) {
					// 401 is for expired token
					// 403 is for forbidden access (blocked by GPT.)
					console.log("user token expired");
					logout();
					navigate("/");
					return;
				}
				setQuestionFlows(questionsFlowResponse?.data);
				flowScores(questionsFlowResponse?.data);
			} catch (e: any) {
				console.log(e);
			}
		};

		const flowScores = async (questionFlows: QuestionFlow[]) => {
			if (!selectedDomain) return;

			try {
				const response = await createAxiosInstance().get(
					user_flow_scores(userId ? userId : 1)
				);

				if (response.status == 401 || response.status == 403) {
					// 401 is for expired token
					// 403 is for forbidden access (blocked by GPT.)
					console.log("use token expired");

					logout();
					window.location.href = "/";
					return;
				}
				setFlowScores(response.data);

				const latestScores = getLatestScores(response.data, questionFlows);
				setLatestScores(latestScores);
			} catch (e) {
				console.log(e, "Error");
			}
		};

		fetchQuestionsFlow();
	}, [selectedDomain]);

	const handleRefresh = () => {
		setRefresh(refresh + 1);
	};

	return (
		<>
			<ChatHeader
				useCase={useCases[useCases.length - 1].value}
				selectUseCase={handleSelect}
			/>
			<main className="d-flex flex-column min-vh-65">
				{/* {selectedDomain && (
					// <QuestionsFlow
					// 	frameworkId={Number(frameworkId)}
					// 	selectedDomain={selectedDomain}
					// 	questionFlows={questionFlows}
					// 	flowScores={flowScores}
					// 	latestScores={latestScores}
					// 	handleGoBack={() => {
					// 		navigate(-1);
					// 	}}
					// 	handleRefresh={handleRefresh}
					// />
				)} */}
			</main>
			<Footer />
			<ChatHistory
				onNavigate={(path: string) => {
					navigate(path);
				}}
			/>
		</>
	);
};

export default MaturityAreas;
